import React, { Component } from 'react';
import './index.less';
import classNames from 'classnames';

class Col extends Component {
    render() {
        let { children, className, style, ...others } = this.props;
        return <div
            {...others}
            className={classNames('low-code-col', className)}
            style={style}
        >
            {children}
        </div>;
    }
}

export default Col;